import axios from "axios";
import { getBackendUrl } from "@/general";


export const dataCostoVentasKardex = async (context, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/consultas/api/dataCostoVentasKardex`,
      data,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch(err) {
    throw err.response;
  }
}

export const dataEventosFacturasVenta = async (context, page, search, filters) => {
  const parameters = {
    ...filters,
    "page": page,
    "search": search
  };
  const paramsHeader = {
    "Authorization": `Bearer ${context.$store.state.user.token}`
  };

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/consultas/api/dataEventosFacturasVenta`,
      {
        params: parameters,
        headers: paramsHeader
      }
    );

    return res.data;
  } catch (err) {
    console.log(err.response.status);
    throw err.response;
  }
}

export const descargarEstadosEventosFacturasVenta = async (context, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/reportes/api/descargaEstadosEventosFacturasVenta`,
      data,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch(err) {
    console.log(err);
    throw err.response;
  }
}

export const dataVentasDiarias = async (context, filters) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/consultas/api/dataVentasDiarias`,
      {
        params: filters,
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch(err) {
    console.log(err);
    throw err.response;
  }
}

export const dataVentasMensual = async (context, filters) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/consultas/api/dataVentasMensuales`,
      {
        params: filters,
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch(err) {
    console.log(err);
    throw err.response;
  }
}
